import Cookie from "js-cookie";
import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
const userSettingStageId = "userSettingStageId";
const userSettingSubjectId = "userSettingSubjectId";
const userSettingTextBookId = "userSettingTextBookId";
export default new Vuex.Store({
  state: {
    // 用户信息
    userInfo: {},
    // 用户教材
    selectedTextbooks: [],
    // 用户当前选中的课程
    currentCourse: null,
    // 当前AI阅读的课程
    currentReadCourse: null,
    // 用户课程
    userCourses: [],
    // 删除的id
    deleteIds: [],
    // 用户真正显示的课程
    showUserCourse: [],
    // 删除之前的用户课程
    beforeDeleteShowUserCourse: [],
    // 选中的目录列表节点id
    // currentTreeNodeId: 0,
    currentTextbook: "",
    systemTools: [],
    // 用户功能模块列表
    userTools: [],
    // 用户上一次设置的学段id
    userSettingStageId: Cookie.get(userSettingStageId) || 0,
    // 用户上一次设置的学科id
    userSettingSubjectId: Cookie.get(userSettingSubjectId) || 0,
    // 用户上一次设置的课程id
    userSettingTextBookId: Cookie.get(userSettingTextBookId) || 0,
    isShowLhsTip: false,
    currentGuideTipClassName: "",
    // 是否是折叠左侧导航
    isFolded: false,
    // 校本子目录
    schoolBaseChildMenu: [],
    // 1--网校通 2--实操实验
    userRoles: [1],
    // 用户权限下的学段学科
    stageListAndSubjects: [],
    // 校本页面添加没有权限的课程校本页面需要更新为当前第一本课程
    isAddNoAuthorizedCourse: false,
    isInIframe: false,
    // 显示添加常用提示
    showAddCommonTip: false,
    // 显示我的权限提示
    showRightsTip: false,
    // 显示我的搜索提示
    showSearchBoxTip: false,
    // 显示实验提示
    showSyTip: false,
    // 显示工作台引导提示
    showDesktopTip: false,
    // 显示添加到备课提示
    showBkTip: false,
    // 显示校本上传提示
    showSchoolBasedTip: false,
    // 显示网校通引导
    showWxtGuidance: false,
    // 显示新手引导流程
    showNoviceGuidanceVisible: false,
    // 显示实验引导
    showSyGuidance: false,
    // 显示添加常用上新提示
    showNewModelGuidance: false,
    // 是否有实验权限
    hasSyRoles: false,
    showNewModalTip: false,
    textBookList: [],
    versionList: [],
    globalPages: [],
    currentGloablPageId: 0,
    stageSubjectList: [],
    // 是否有使用过的课程
    hasAiUsedCourses: true,
    // currentGlobalPageId:1
    // currentTextbook
    isFullScreen: false,
  },
  mutations: {
    // 获取用户信息
    changeUser(state, params) {
      state.userInfo = params;
    },
    changeCurrentGloablPageId(state, params) {
      state.currentGloablPageId = params;
    },
    changeStageSubjectList(state, params) {
      state.stageSubjectList = params;
    },
    changeShowWxtGuidance(state, params) {
      state.showWxtGuidance = params;
    },
    changeHasAiUsedCourses(state, params) {
      state.hasAiUsedCourses = params;
    },
    changeGlobalPages(state, params) {
      state.globalPages = params;
    },
    changeTextBookList(state, params) {
      state.textBookList = params;
    },
    changeVersionList(state, params) {
      state.versionList = params;
    },
    changeCurrentTextBook(state, params) {
      state.currentTextbook = params;
    },
    changeShowNoviceGuidanceVisible(state, params) {
      state.showNoviceGuidanceVisible = params;
    },
    changeShowNewModalTip(state, params) {
      state.showNewModalTip = params;
    },
    changeShowNewModelGuidance(state, params) {
      state.showNewModelGuidance = params;
    },
    changeShowSyGuidance(state, params) {
      state.showSyGuidance = params;
    },
    changeHasSyRoles(state, params) {
      state.hasSyRoles = params;
    },
    changeIsInIframe(state, params) {
      state.isInIframe = params;
    },
    changeShowDesktopTip(state, params) {
      state.showDesktopTip = params;
    },
    changeShowAddBkTip(state, params) {
      state.showBkTip = params;
    },
    changeSchoolBasedTip(state, params) {
      state.showSchoolBasedTip = params;
    },
    changeIsAddNoAuthorizedCourse(state, params) {
      state.isAddNoAuthorizedCourse = params;
    },
    changeShowAddCommonTip(state, params) {
      state.showAddCommonTip = params;
    },
    changeShowSearchBoxTip(state, params) {
      state.showSearchBoxTip = params;
    },
    changeShowSyTip(state, params) {
      state.showSyTip = params;
    },
    changeShowRightsTip(state, params) {
      state.showRightsTip = params;
    },
    // 获取用户教材
    setTextbooks(state, params) {
      state.selectedTextbooks = params;
    },
    setUserTools(state, params) {
      state.userTools = params;
    },
    changeSystemTools(state, params) {
      state.systemTools = params;
    },
    // 设置当前课程
    setCurrentCourse(state, params) {
      // console.log("设置课程", params);
      state.currentCourse = params;
      // let xbIframe = document.getElementById('xbIframe')
      // console
      // let message = {
      //   // data:{
      //   type: "updateCoursesBook",
      //   params: {
      //     stageId: params.stageId,
      //     subjectId: params.subjectId,
      //     courseId: params.courseId,
      //   },
      //   // }
      // };
      // if(xbIframe){
      //   xbIframe.postMessage(JSON.stringify(message))
      // }
    },
    setCurrentReadCourse(state, params) {
      state.currentReadCourse = params;
    },
    // 设置删除的id
    setDeleteIds(state, params) {
      state.deleteIds = params;
    },
    // 获取用户课程
    setCourses(state, params) {
      state.userCourses = params;
    },
    setShowUserCourse(state, params) {
      state.showUserCourse = params;
    },
    setBeforeDeleteShowUserCourse(state, params) {
      state.beforeDeleteShowUserCourse = params;
    },
    setStageId(state, params) {
      Cookie.set(userSettingStageId, params);
      state.userSettingStageId = params;
    },
    setSubjectId(state, params) {
      Cookie.set(userSettingSubjectId, params);
      state.userSettingSubjectId = params;
    },
    setTextBookId(state, params) {
      Cookie.set(userSettingTextBookId, params);
      state.userSettingTextBookId = params;
    },
    changeShowLhsTip(state, params) {
      state.isShowLhsTip = params;
    },
    setCurrentGuideTipClassName(state, params) {
      state.currentGuideTipClassName = params;
    },
    changeIsFolded(state, params) {
      state.isFolded = params;
    },
    setSchoolBaseChildMenu(state, params) {
      state.schoolBaseChildMenu = params;
    },
    // setCurrentTreeNodeId(state, id) {
    //   state.currentTreeNodeId = id;
    // },
    // 修改用户权限
    changeUserRoles(state, params) {
      state.userRoles = params;
    },
    // 设置用户权限的学段学科
    setStageListAndSubjects(state, params) {
      state.stageListAndSubjects = params;
    },
    SET_FULLSCREEN(state, status) {
      state.isFullScreen = status;
    },
  },
  // 异步方法 调用方法,this.$store.dispatch("xxx")
  actions: {
    changeUserAct(context, params) {
      //context是一个对象，从它里面把咱们需要的commit方法解构出来
      let { commit } = context;
      commit("changeUser", params);
    },
    changeBookListAct(context, params) {
      //context是一个对象，从它里面把咱们需要的commit方法解构出来
      let { commit } = context;
      commit("changeBookList", params);
    },
    changeUserTools(context, params) {
      //context是一个对象，从它里面把咱们需要的commit方法解构出来
      let { commit } = context;
      commit("setUserTools", params);
    },
    updateFullScreenStatus({ commit }, status) {
      commit("SET_FULLSCREEN", status);
    },
  },
  // Vuex属性计算,在视图里面当变量使用
  getters: {},
  // 模块化注册
  modules: {},
});
